import { DatePipe } from '@angular/common';
import { Component, input } from '@angular/core';
import { FinancialAsset } from '@app/models/project.models';
import { LabeledContentComponent } from '@app/ui-components/labeled-content/labeled-content.component';

@Component({
  selector: 'app-not-owned-devices-display',
  imports: [DatePipe, LabeledContentComponent],
  templateUrl: './not-owned-devices-display.component.html',
  styleUrl: './not-owned-devices-display.component.scss',
})
export class NotOwnedDevicesDisplayComponent {
  financialAsset = input.required<FinancialAsset>();
}
